import { defaultStore } from 'app/gamma/src/defaultStore';
import {
  setHeaderBrandingName,
  removeHeaderBrandingName,
} from 'app/gamma/src/modules/state/ui/header';

interface HeaderOptions {
  headerBrandingColor?: string;
  headerBrandingLogo?: string;
  headerBrandingName?: string;
}

export const headerBranding = (opts: HeaderOptions) => {
  if (opts.headerBrandingName) {
    defaultStore.dispatch(setHeaderBrandingName(opts.headerBrandingName));
  } else {
    defaultStore.dispatch(removeHeaderBrandingName());
  }
};
